import {
  Radar, RadarChart as RechartsRadar, PolarGrid,
  PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip
} from 'recharts';
import { PILLARS } from '../utils/scoring';

const COMP_COLORS = ['#f87171', '#60a5fa', '#c084fc', '#34d399', '#fb923c'];

export default function RadarChart({ scores, competitors = [], showBenchmark = false }) {
  const data = PILLARS.map((pillar) => {
    const entry = {
      pillar: pillar.name.replace('& Ingredient', '& Ingr.').replace('Program', 'Prog.'),
      fullName: pillar.name,
      score: scores[pillar.id]?.score || 0,
    };
    competitors.forEach((comp) => {
      const key = `comp_${comp.originalIndex ?? comp.name}`;
      entry[key] = comp.scores?.[pillar.id]?.score || 0;
    });
    return entry;
  });

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2 text-xs shadow-xl">
          <p className="text-white font-medium mb-1">{payload[0]?.payload?.fullName}</p>
          {payload.map((entry, i) => (
            <p key={i} style={{ color: entry.color }} className="flex justify-between gap-3">
              <span>{entry.name}:</span>
              <span className="font-bold">{entry.value.toFixed(1)}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full" style={{ height: 380 }}>
      <ResponsiveContainer>
        <RechartsRadar cx="50%" cy="50%" outerRadius="75%" data={data}>
          <PolarGrid stroke="rgba(255, 255, 255, 0.1)" />
          <PolarAngleAxis
            dataKey="pillar"
            tick={{ fill: '#a3a3a3', fontSize: 10 }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 10]}
            tick={{ fill: '#525252', fontSize: 9 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Radar
            name="This Property"
            dataKey="score"
            stroke="#C9A668"
            fill="#C9A668"
            fillOpacity={0.25}
            strokeWidth={2}
          />
          {competitors.map((comp) => (
            <Radar
              key={comp.originalIndex ?? comp.name}
              name={comp.name}
              dataKey={`comp_${comp.originalIndex ?? comp.name}`}
              stroke={comp.color?.hex || COMP_COLORS[(comp.originalIndex || 0) % COMP_COLORS.length]}
              fill={comp.color?.hex || COMP_COLORS[(comp.originalIndex || 0) % COMP_COLORS.length]}
              fillOpacity={0.08}
              strokeWidth={1.5}
            />
          ))}
          {(competitors.length > 0) && (
            <Legend wrapperStyle={{ fontSize: 11, color: '#a3a3a3' }} />
          )}
        </RechartsRadar>
      </ResponsiveContainer>
    </div>
  );
}
